export function dealSourceType(sourceType) {
    switch (sourceType) {
        case 1:
            return '流拍撮合';
        case 2:
            return '撮合成交';
        case 0:
        default:
            return '正常成交';
    }
}
